import "core-js";
import "regenerator-runtime/runtime";
import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import "./stylesheets/index.sass";

import AppContainer from "./containers/app";
import configureStore from "./store";
import createErrorBoundary from "shared/components/wrappers/errorBoundary";
import { loadState, mergeStates, saveStateSlice } from "./localStorage";

const persistedState = loadState();
const initialState = mergeStates(window.PRELOAD_STATE, persistedState);
const store = configureStore(initialState);

store.subscribe(() => {
  const state = store.getState();
  saveStateSlice({
    segments: state.segments,
    currently_transcribing_id:
      state.transcription == null ? null : state.transcription.display_id,
    local: state.local,
  });
});

if (process.env.NODE_ENV !== "production") {
  window.store = store;
}

const ErrorBoundedApp = createErrorBoundary()(AppContainer);

ReactDOM.render(
  <Provider store={store}>
    <DndProvider backend={HTML5Backend}>
      <ErrorBoundedApp store={store} />
    </DndProvider>
  </Provider>,
  document.getElementById("root")
);
